import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// --------------- END OF IMPORTS ---------------

// Home
import Home from './pages/Home';

// Authentication Pages
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';

// Navbar Main Pages
import Friends from './pages/Friends';
import Explore from './pages/Explore';
import CreateEvent from './pages/CreateEvent';
import AdminPanel from './pages/AdminPanel';

// Event Pages
import EventDetails from './pages/EventDetails';

// Profile Pages
import UserProfile from './pages/UserProfile';
import MyPasses from './pages/MyPasses';
import MyEvents from './components/ProfileDetails/MyEvents';
import ConfigProfile from './components/ProfileDetails/ConfigProfile';

// QRs Pages
import QRPage from './pages/QRPage';
import QRScanner from './pages/QRScanner';
import QRRequestConfirmation from './pages/QRRequestConfirmation';

// Component
import ScrollToTop from './components/ScrollToTop';
import Navigation from './components/Navigation';

// Soporte
import ArmaTuEvento from './pages/soporte/ArmaTuEvento';
import TerminosCondiciones from './pages/soporte/TerminosCondiciones';
import Soporte from './pages/soporte/Soporte';
import AboutUs from './pages/soporte/AboutUs';
import Careers from './pages/soporte/Careers';

// --------------- END OF PAGES ---------------

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen max-w-screen bg-black">
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/explore" element={<Explore />} />
            <Route path="/create" element={<CreateEvent />} />
            
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/configprofile" element={<ConfigProfile />} />

            <Route path="/profile" element={<UserProfile />} />
            <Route path="/profile/:id" element={<UserProfile />} />
            <Route path="/friends" element={<Friends />} />
            <Route path="/passes" element={<MyPasses />} />
            <Route path="/my-events" element={<MyEvents />} />
            <Route path="/qr-scanner" element={<QRScanner />} />

            <Route path="/event/:id" element={<EventDetails />} />
            
            <Route path="/qr/:eventId" element={<QRPage />} />
            <Route path="/qr-request-confirmation/:eventName" element={<QRRequestConfirmation />} />
            
            <Route path='/infoevents' element={<ArmaTuEvento />} />
            <Route path='/about' element={<AboutUs />} />
            <Route path='/support' element={<Soporte />} />
            <Route path='/terminos' element={<TerminosCondiciones />} />
            <Route path='/carrera' element={<Careers />} />


          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}